// Vendor category map — bridges the broad vendor families (what buyers of
// talent typically search for) and the granular technology items candidates
// select on the SoverenX prescreening form.
//
// Rule of thumb:
//   - Pick a BROAD CATEGORY when you want "any Fortinet person" → matches all
//     Fortinet-family techs the candidate ticked.
//   - EXPAND the category to drill down to a specific product (e.g. "FortiSASE
//     and ZTNA only, not just FortiGate admins").
//
// If this list changes, keep /app/frontend/src/pages/OnboardPersonnel.jsx VENDORS
// in sync — same strings, same casing.
export const VENDOR_CATEGORIES = [
  {
    key: "Fortinet",
    label: "Fortinet",
    techs: ["FortiGate", "FortiManager", "FortiAnalyzer", "WiFi", "FortiSIEM", "FortiSASE and ZTNA"],
  },
  {
    key: "PaloAlto",
    label: "Palo Alto",
    techs: ["Palo Alto Prisma", "Palo Alto Panorama", "Palo Alto Firewall"],
  },
  {
    key: "F5",
    label: "F5",
    techs: ["F5 LTM", "F5 GTM"],
  },
  {
    key: "Cisco",
    label: "Cisco",
    techs: ["Cisco Nexus", "Cisco Routers and Switches"],
  },
  {
    key: "Cloud",
    label: "Cloud (Azure / AWS / GCP)",
    techs: ["Azure infrastructure", "AWS infrastructure", "GCP infrastructure"],
  },
  { key: "CheckPoint", label: "Check Point", techs: ["Check Point"] },
  { key: "Sophos",     label: "Sophos",      techs: ["Sophos"] },
  { key: "Zscaler",    label: "Zscaler",     techs: ["Zscaler"] },
  { key: "Juniper",    label: "Juniper",     techs: ["Juniper"] },
];

// Reverse lookup — given a tech string, which category key does it belong to?
export const TECH_TO_CATEGORY = VENDOR_CATEGORIES.reduce((acc, c) => {
  c.techs.forEach((t) => { acc[t] = c.key; });
  return acc;
}, {});

// Does an engineer's vendor list match any of the selected categories/techs?
//   selectedCategoryKeys: Set<string>   — e.g. {"Fortinet"}
//   selectedTechs:        Set<string>   — e.g. {"FortiSASE and ZTNA"}
// An engineer matches if ANY of their vendors falls under any selected category
// OR equals any selected tech. (OR logic across the filter — union, not intersection.)
export function engineerMatchesVendorFilter(engineerVendors, selectedCategoryKeys, selectedTechs) {
  const vendors = engineerVendors || [];
  if (!selectedCategoryKeys?.size && !selectedTechs?.size) return true;
  if (!vendors.length) return false;
  // Category match: any of the engineer's vendors maps to a selected category
  for (const v of vendors) {
    const cat = TECH_TO_CATEGORY[v];
    if (cat && selectedCategoryKeys?.has(cat)) return true;
    if (selectedTechs?.has(v)) return true;
  }
  return false;
}
